(function () {
  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === "function") {
      return window.theme.formatMoney(
        cents,
        window.theme.moneyFormat || "${{amount}}",
      );
    }
    return (cents / 100).toFixed(2);
  }

  function updateGiftBar(subtotalCents) {
    const bars = document.querySelectorAll("[data-gift-progress]");
    if (!bars.length) return;

    const subtotal = (subtotalCents || 0) / 100;

    bars.forEach((bar) => {
      const gift1Threshold =
        parseFloat(bar.getAttribute("data-gift-1-threshold")) || 0;
      const gift1Name = bar.getAttribute("data-gift-1-name") || "";
      const gift2Threshold =
        parseFloat(bar.getAttribute("data-gift-2-threshold")) || 0;
      const gift2Name = bar.getAttribute("data-gift-2-name") || "";

      if (!gift1Threshold) return;

      const hasTier2 = gift2Threshold > 0;
      const finalThreshold = hasTier2 ? gift2Threshold : gift1Threshold;

      let nextThreshold = gift1Threshold;
      let nextName = gift1Name;
      let allComplete = false;

      if (subtotal >= gift1Threshold) {
        if (hasTier2) {
          nextThreshold = gift2Threshold;
          nextName = gift2Name;
        } else {
          allComplete = true;
        }
      }
      if (hasTier2 && subtotal >= gift2Threshold) {
        allComplete = true;
      }

      const remaining = Math.max(nextThreshold - subtotal, 0);
      const percent = Math.min((subtotal * 100) / finalThreshold, 100);

      const messageEl = bar.querySelector("[data-gift-message]");
      const progressEl = bar.querySelector("[data-gift-progress-bar]");

      if (messageEl) {
        if (allComplete) {
          messageEl.textContent = "Tebrikler! Tüm hediyeleri kazandın! 🎁";
        } else {
          messageEl.innerHTML = `${formatMoney(remaining * 100)} daha ekle, ${nextName} kazan!`;
        }
      }

      if (progressEl) {
        progressEl.value = percent;
      }

      bar.classList.toggle("is-success", allComplete);
    });
  }

  function fetchCartAndUpdate() {
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    fetch(`${root}cart.js`)
      .then((res) => res.json())
      .then((cart) => updateGiftBar(cart.total_price))
      .catch(() => {});
  }

  document.addEventListener("theme:product:added", fetchCartAndUpdate);
  document.addEventListener("theme:cart:change", fetchCartAndUpdate);
  document.addEventListener("DOMContentLoaded", fetchCartAndUpdate);
})();
